import Vue from 'vue';
import VueCookies from 'vue-cookies';

Vue.use(VueCookies);

// Configura opciones (opcional)
Vue.$cookies.config('7d'); // Configura la expiración global de las cookies
